import { IS_DEVELOPMENT_ENV, SPAYEE_MANAGE_API_BASE, SPAYEE_MANAGE_TOKEN } from '@shared-constants/env/internalService.constants';
import axios from 'axios';
import requestIp from 'request-ip';

export class IpInfoAPI {
async getIpInfo() {
  const GET_IP_INFO = "https://ipinfo.io";
  const SPAYEE_COUNTRY_API = "/api/country-code";
  const res = await axios(
      {
        url: `${GET_IP_INFO}/json`,
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }
    ).then((res) => {
      const response = res as any;
      response.success = true;
      response.data = {...response.data, success: true};
      return response;
    })
      .catch(() => {
        return axios({
          url: `${SPAYEE_COUNTRY_API}`,
          method: 'GET'
        });
      });
    return (res as { data: any }).data;
  }

async getReaderIpInfo(req: any) {
    const detectedIp = IS_DEVELOPMENT_ENV? '':`&ip=${requestIp.getClientIp(req)}`;
    return axios({
    method: 'GET',
    url: `https://${SPAYEE_MANAGE_API_BASE}/readerapi/graphy/ip/country/get?token=${SPAYEE_MANAGE_TOKEN}${detectedIp}`
  })
}
}
